import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['months', 'price', 'periodLabel', 'annualLabel', 'monthlyLabel'];

  static activeLabelClassList = ['font-bold', 'text-black'];

  static inactiveLabelClassList = ['text-gray-500'];

  connect() {
    this.applyPeriod(false);
  }

  toggle(event) {
    this.applyPeriod(event.target.checked);
  }

  applyPeriod(monthly) {
    this.monthsTargets.forEach((field) => {
      field.value = monthly ? '1' : '12';
    });

    this.priceTargets.forEach((price) => {
      price.textContent = monthly ? price.dataset.monthly : price.dataset.annual;
    });

    this.periodLabelTargets.forEach((label) => {
      label.textContent = monthly ? 'Rozliczanie miesięczne' : 'Rozliczanie roczne';
    });

    this.highlightActiveLabel(monthly);
  }

  highlightActiveLabel(monthly) {
    if (!this.hasAnnualLabelTarget || !this.hasMonthlyLabelTarget) return;

    const activeLabel = monthly ? this.monthlyLabelTarget : this.annualLabelTarget;
    const inactiveLabel = monthly ? this.annualLabelTarget : this.monthlyLabelTarget;

    activeLabel.classList.add(...this.constructor.activeLabelClassList);
    activeLabel.classList.remove(...this.constructor.inactiveLabelClassList);
    inactiveLabel.classList.add(...this.constructor.inactiveLabelClassList);
    inactiveLabel.classList.remove(...this.constructor.activeLabelClassList);
  }
}
